<template>

  <div>

    <my-header> </my-header>
    <div class="mainWrap">
      <div class="main">
        <div class="breadCrumbs">
          <h3>{{productname}}</h3>
          <span>
            <a>首页</a> &gt;
            <router-link to="/MixedCellSeries">
              <a>产品</a> &gt;
            </router-link>
            <a>{{productname}}</a> &gt;
            <em>{{productlist.title}}</em>
          </span>
        </div>

        <!--内容开始-->
        <div class="content">
          <div class="cr_protab">
            
              <a @click="entercolor()">选择颜色</a>
           
           
              <a  @click="enterbox()">选择线材和包装盒</a>
          

            <a class="cur">确认购买</a>
          </div>
          <div class="probuy_threecon">
            <div class="probuy_add">请确认以下信息无误</div>
            <ul class="probuy-wrapper">
              <li>
                <div class="td proimg"
                     width="288">
                  <img class="probuy_threeimg"
                       width="124"
                       height="124"
                       :src="httpurl+YwwpicRight.image"
                       alt="" />
                  <img class="probuy_threeimg"
                       width="124"
                       height="124"
                       :src="httpurl+YwwLagre.image"
                       alt="" />
                  <img :src="httpurl+Baozhuang.image"
                       width="124"
                       height="124"
                       alt="">
                  <img :src="httpurl+Xiancai.image"
                       width="124"
                       height="124"
                       alt="" />
                </div>
                <div class="td protitle"
                     width="294">
                  <p class="pro_zhiwei">{{productlist.name}}</p>
                  <div class="desc">
                    <p>
                      线材：{{Xiancai.name}} ￥{{Xiancai.price*newdiscount|toFixed(2)}}
                    </p>
                    <p>
                      包装盒：{{Baozhuang.name}} ￥{{Baozhuang.price*newdiscount|toFixed(2)}}
                    </p>
                     <p v-show="productlist.iscolor!==0&&this.addprice!==0">
                                面板颜色:￥{{addprice*newdiscount|toFixed(2)}}
                    </p>
                  </div>
                </div>
                <div class="td proprice"
                     width="150"
                     v-if="ukey==0">
                  <p class="font18">单价</p>
                  <p data-price="6180.00">￥{{productlist.price|toFixed(2)}}</p>
                </div>
                <div class="td proprice"
                     width="150"
                     v-if=" this.ukey==0&&this.$route.query.productmoreid">
                  <p class="font18">会员单价</p>
                  <p data-price="6180.00">￥{{memberprice|toFixed(2)}}</p>
                </div>
               
                <div class="td proprice"
                     width="150"
                     v-if="ukey!=0">
                  <p class="font18">会员单价</p>
                  <p data-price="6180.00">￥{{memberprice|toFixed(2)}}</p>
                </div>
                <div class="td pronum"
                     width="185">
                  <p class="font18">数量</p>
                  <p>
                      <el-input-number v-model="Pnumber" @change="handleChange" :min="1" ></el-input-number>
                    <!-- <a href="javascript:;"
                       class="pro_numadd"
                       @click="minus()"></a>
                       
                    <input class="pro_numlabel"
                           type="text"
                           id="txtNum"
                           v-model='Pnumber' v-on:keyup="PnumberValue" >
                    <a href="javascript:;"
                       class="pro_numsubtract"
                       @click="add()"></a> -->
                  </p>
                </div>
                <div class="td prosum">
                  <p class="font18">小计</p>
                  <p id="pTotal">￥{{Allsum|toFixed(2)}}</p>
                </div>
              </li>
            </ul>

            <div class="probuy_list">
              <p class="probuy_three_price">￥{{Allsum|toFixed(2)}}</p>
              <p class="probuy_three_integral"
                 v-if="jyzshow">获得{{point}}经验值</p>
              <p class="probuy_three_jiesuan"><a href="javascript:;"
                   id="linkNext"
                   @click="OderCenter(Pnumber,Allsum)">结 算</a></p>
            </div>
          </div>
        </div>

        <!--内容结束-->
      </div>
    </div>
  </div>

</template>
<script>
import { mapActions, mapGetters } from "vuex";
import myHeader from "@/views/detailimg";
import { getpoinxx ,gzkxx,getpro} from '@/api/api'
export default {
  components: { myHeader },
  data () {
    return {
      jyzshow: false,
      shownum: false,
      httpurl: "http://shop.qdc.com/",
      daohang: false, //显示导航
      screenWidth: document.body.clientWidth, // 屏幕尺寸
      Pnumber: 1,
      Allsum: '',
      ukey: 0,
      point: 0,
      memberprice:0,
      newdiscount:1,
      addprice:0,
    };
  },

  created () {
      if(localStorage.getItem('addprice')){
        this.addprice=localStorage.getItem('addprice')
    }
    if (localStorage.getItem("prpductnewlist") != null) {
      var list = JSON.parse(localStorage.getItem('prpductnewlist'));
      this.productlist = list
      this.productid = list.id
      if(this.ukey==0&&this.$route.query.productmoreid==2){
           this.memberprice=list.aprice
      }
      if(this.ukey==0&&this.$route.query.productmoreid==3){
           this.memberprice=list.bprice
      }
    }
    if (localStorage.getItem("newChildproductlist") != null) {
      var list2 = JSON.parse(localStorage.getItem('newChildproductlist'));
      this.productname = list2.name
    }else{
        if(this.$route.query.productmoreid){
             var list = JSON.parse(localStorage.getItem('prpductnewlist'));
            this.productname = list.parentname
        }
    }
    if (localStorage.getItem("newYwwLagre") != null) {
      var newYwwLagre = JSON.parse(localStorage.getItem('newYwwLagre'));
      this.YwwLagre = newYwwLagre

    }
    if (localStorage.getItem("newYwwpicRight") != null) {
      var newYwwpicRight = JSON.parse(localStorage.getItem('newYwwpicRight'));
      this.YwwpicRight = newYwwpicRight

    }
    if (localStorage.getItem("newXiancai") != null) {
      var newXiancai = JSON.parse(localStorage.getItem('newXiancai'));
      this.Xiancai = newXiancai

    } else {
      this.Xiancai = ''
    }
    if (localStorage.getItem("newBaozhaung") != null) {
      var newBaozhaung = JSON.parse(localStorage.getItem('newBaozhaung'));
      this.Baozhuang = newBaozhaung

    } else {
      this.Baozhuang = ''
    }
    if (localStorage.getItem("newaddinfo") != null) {
      var list3 = JSON.parse(localStorage.getItem('newaddinfo'));
      this.addinfo == list3

    }
    if (localStorage.getItem("newsum") != null) {
      var newsum = JSON.parse(localStorage.getItem('newsum'));
      this.sum = newsum
      this.Allsum = newsum
    } else {
      this.sum = 0
      this.Allsum = 0
    }
if(this.ukey==0&&this.$route.query.productmoreid){
    if(localStorage.getItem('discount')){
 this.newdiscount=localStorage.getItem('discount')

    }
  
}

    
    this.getukey()
    window.screenWidth = document.body.clientWidth;
    this.daohang = window.screenWidth > 1024 ? true : false;
  },
  mounted () {
    
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        // console.log(window.screenWidth);
        this.daohang = window.screenWidth > 1024 ? true : false;
      })();
    };
  },
  computed: {
    //    addinfo() {
    //   return this.$store.state.addinfo;
    // },
    // sum() {
    //   return this.$store.state.sum;
    // },
    // YwwpicRight() {
    //   return this.$store.state.YwwpicRight;
    // },
    // YwwLagre() {
    //   return this.$store.state.YwwLagre;
    // },
    // Xiancai() {
    //   return this.$store.state.Xiancai;
    // },
    // Baozhuang() {
    //   return this.$store.state.Baozhuang;
    // },
    // productname() {
    //   return this.$store.state.productname;
    // },
    // productlist() {
    //   return this.$store.state.productlist;
    // }
  },
  methods: {
     
       enterbox () {
           var newsum2=parseFloat (this.$Base64.decode(this.$route.query.newsum))
 if(this.$route.query.productmoreid){
      this.$router.push({
          path: '/PurchaseFusionBox',
          query: {
            ukey:this.ukey,
            // newsum:this.$route.query.newsum,
              newsum: this.$Base64.encode(newsum2),
            productmoreid:this.$route.query.productmoreid
          }

        });
 }else{
      this.$router.push({
          path: '/PurchaseFusionBox',
          query: {
            ukey:this.ukey,
            // newsum:this.$route.query.newsum
             newsum: this.$Base64.encode(newsum2),
          }

        });
 }

      
      alert("返回将重新选择，是否确定？");
    },
       entercolor () {
             if(this.$route.query.productmoreid){

                  this.$router.push({
          path: '/PurchaseFusion',
          query: {
            childid: this.productid,
            ukey:this.ukey,
            discount:localStorage.getItem('discount'),
        productmoreid:this.$route.query.productmoreid
          }

        });
             }else{
this.$router.push({
          path: '/PurchaseFusion',
          query: {
            childid: this.productid,
            ukey:this.ukey,
            discount:localStorage.getItem('discount'),
        
          }

        });
             }
       
      alert("返回将重新选择，是否确定？");
    },
       handleChange(value) {
           this.Pnumber=value
           this.Allsum = this.Pnumber * this.sum;
           this.getpoinxxlist()
        
      },
   
//     PnumberValue: function(e){
       
       
//          let  flag = new RegExp("^[1-9]([0-9])*$").test(e.target.value);           
//               if (!flag) {
//               this.Pnumber=''
//               }else{
//                 this.Pnumber = e.target.value
//                 this.Allsum = parseFloat(this.Pnumber) * parseFloat(this.sum);
//             }
//     },
    
       //折扣价
    gzkxxList () {
    
      var para = {
        token: sessionStorage.getItem('token'),
        ukey: this.ukey,
      };
      gzkxx(para).then(res => {
        if (res.data.error_code == 200) {
            if(this.$route.query.productmoreid==2){
                 this.memberprice = this.productlist.aprice
                //    this.newdiscount=res.data.pro.abfb
            } else if(this.$route.query.productmoreid==3){
                 this.memberprice = this.productlist.bprice
                //    this.newdiscount=res.data.pro.bbfb
            }
            else{
                this.newdiscount=res.data.zk
this.memberprice = this.productlist.price*res.data.zk
            }
            
        } else {
          console.info("调用失败", res);
        }
      }).catch(err => { console.info("调用失败", err); })
    },
      getukey(){
          
   if (localStorage.getItem('newukey') == '' || localStorage.getItem('newukey') == null) {
        this.ukey = 0
      }else{
          this.ukey=localStorage.getItem('newukey')
      }
    // if()
      this.gzkxxList()
      this.getpoinxxlist()
  },
    getpoinxxlist () {
      
      var para = {
        ukey: this.ukey,
        proid: this.productid,
        price: this.Allsum
      };
      getpoinxx(para).then(res => {
        if (res.data.error_code == 200) {
          this.point = res.data.point
          
          this.jyzshow = true
        } else {
          this.jyzshow = false
          console.info("请求失败", err);
        }
      }).catch(err => { console.info("调用失败", err); })
    },

    //通过点击按钮显示移动端导航
    showdao () {
      this.daohang = !this.daohang;
    },
    //跳转产品页面
    Toproduct () {
      this.$router.push("/");
      if (window.screenWidth < 1024) {
        this.daohang = !this.daohang;
      }
    },

    OderCenter (Pnumber, Allsum) {

if(this.Pnumber==''||this.Pnumber==0){
     this.$message({
          message: "请输入正整数",
          type: 'error'
        });
        return;
}


      if (this.ukey == 0) {
        alert('请先登录')
        if (this.productlist.iscolor == 0) {
          window.location.href = 'http://shop.qdc.com/member/login.html?lx=1&fl=1'
        } else {
          window.location.href = 'http://shop.qdc.com/member/login.html?lx=1&fl=2'
        }

      } 
      else if(this.ukey!==0){
            if(this.$route.query.productmoreid){
                sessionStorage.setItem('newchooseprice',this.Allsum)
                //   console.log("Allsum:"+this.Allsum)
                this.$router.push({
        path: '/OderCenter',
        query: {
          //    childid: item.id
          ukey: this.ukey, 
          productmoreid:this.$route.query.productmoreid,
          type:0,
        //   point:this.point  ,    
        }
      });

            }else {
       
         this.$router.push({
        path: '/OderCenter',
        query: {
          //    childid: item.id
          ukey: this.ukey, 
        //   point:this.point  ,    
        }
      });
      }
      }
      
      

      this.$store.dispatch("ChangePnumber", Pnumber);
      this.$store.dispatch("ChangeAllsum", Allsum);
    },
    // add: function () {
    //   if (this.Pnumber > 1||this.Pnumber == 1) {
    //     this.Pnumber++;
    //      this.Allsum = parseFloat(this.Pnumber) * parseFloat(this.sum);
    //      console.log('sum:'+this.sum)
    //       console.log('Allsum:'+this.Allsum)
    //   }

     
     
    // },
    // minus: function () {
    //   if (this.Pnumber > 1) {
    //     this.Pnumber--;
    //      this.Allsum = parseFloat(this.Pnumber) * parseFloat(this.sum);
    //        console.log('sum:'+this.sum)
    //       console.log('Allsum:'+this.Allsum)
    //   } 
     
    // }
  }
};
</script>

<style scoped>
@import "../../static/newlayout.css";

</style>


// WEBPACK FOOTER //
// src/views/EnterPurchase.vue